export enum DqButtonLocation {
	CFDefGroup = 'CFDefGroup',
	headerPersSelect = 'headerPersSelect',
	maintenanceTableHeader = 'maintenanceTableHeader',
	maintenanceRow = 'maintenanceRow',
	onClientHeaderPersSelect = 'onClientHeaderPersSelect',
	PersTooltipNewTabAll = 'PersTooltipNewTabAll',
	PersTooltipNewTab = 'PersTooltipNewTab',
	PersTooltipNewTabFrontView = 'PersTooltipNewTabFrontView',
	SheetCellNewTab = 'SheetCellNewTab',
	TaskMultiSelect = 'TaskMultiSelect',
	TaskTooltipNewTab = 'TaskTooltipNewTab',
}

export interface DqButtonPosition {
	location: DqButtonLocation
	locationDiscriminator?: string | null
}

export const NewTabDqButtonLocations = [
	DqButtonLocation.PersTooltipNewTabAll,
	DqButtonLocation.PersTooltipNewTab,
	DqButtonLocation.PersTooltipNewTabFrontView,
	DqButtonLocation.SheetCellNewTab,
	DqButtonLocation.TaskTooltipNewTab,
]
